import { render, staticRenderFns } from "./CommonCase.vue?vue&type=template&id=688c3951&scoped=true&"
import script from "./CommonCase.vue?vue&type=script&lang=js&"
export * from "./CommonCase.vue?vue&type=script&lang=js&"
import style0 from "./CommonCase.vue?vue&type=style&index=0&id=688c3951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c3951",
  null
  
)

export default component.exports